import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border: 1px solid #edeef2;
  border-radius: 8px;
  background: #ffffff;
`;

export const HorizontalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* padding: 12px; */
  /* border: 1px solid #edeef2; */
  /* border-radius: 8px; */
  background: #ffffff;
`;

export const HorizontalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Panel = styled.div`
  display: flex;
  min-height: 240px;
  border: 1px solid #edeef2;
  border-radius: 8px;
  overflow: hidden;
`;

export const Column = styled.div`
  width: 30%;
  background: #fbfcfc;
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
`;

export const Content = styled.div`
  flex: 1;
  padding: 12px;
  overflow-y: auto;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const HorizontalGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
`;

export const VerticalWrapper = styled.div`
  border: 1px solid #edeef2;
  border-radius: 8px;
  background: #ffffff;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const VerticalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const VerticalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const VerticalSection = styled.div`
  border: 1px solid #edeef2;
  border-radius: 8px;
  background: #fbfcfc;
  padding: 10px;
  min-height: 120px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: 8px;
`;
